import React, { useState } from 'react';
import { 
  FaBuilding,
  FaChevronDown,
  FaChevronRight,
  FaSitemap
} from 'react-icons/fa';
import styles from '../CSS/OrganizationalUnits.module.css';

const OrganizationalUnits = ({ 
  organizationalUnits, 
  selectedOU, 
  onOUSelect, 
  isMobile 
}) => {
  const [expandedOUs, setExpandedOUs] = useState(new Set());
  const [isDragging, setIsDragging] = useState(false);
  const [panelWidth, setPanelWidth] = useState(350);

  const toggleOUExpansion = (ouPath) => {
    const newExpanded = new Set(expandedOUs);
    if (newExpanded.has(ouPath)) {
      newExpanded.delete(ouPath);
    } else {
      newExpanded.add(ouPath);
    }
    setExpandedOUs(newExpanded);
  };

  // Resize handler para desktop
  const handleMouseDown = (e) => {
    if (isMobile) return;
    
    setIsDragging(true);
    const startX = e.clientX;
    const startWidth = panelWidth;

    const handleMouseMove = (e) => {
      const newWidth = Math.max(250, Math.min(500, startWidth + (e.clientX - startX)));
      setPanelWidth(newWidth);
    };

    const handleMouseUp = () => {
      setIsDragging(false);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const renderOUTree = (ous, level = 0) => {
    return ous.map(ou => (
      <div 
        key={ou.orgUnitPath} 
        className={styles.ouItem} 
        style={{ marginLeft: `${level * 15}px` }}
      >
        <div 
          className={`${styles.ouHeader} ${selectedOU === ou.orgUnitPath ? styles.selectedOUHeader : ''}`}
        >
          {ou.children.length > 0 && (
            <button
              onClick={() => toggleOUExpansion(ou.orgUnitPath)}
              className={styles.expandButton}
            >
              {expandedOUs.has(ou.orgUnitPath) ? <FaChevronDown /> : <FaChevronRight />}
            </button>
          )}
          
          <FaBuilding className={styles.ouIcon} />
          
          <span 
            className={`${styles.ouName} ${selectedOU === ou.orgUnitPath ? styles.selectedOU : ''}`}
            onClick={() => onOUSelect(ou.orgUnitPath)}
          >
            {ou.name}
          </span>
          
          {/* CAMBIO CLAVE AQUÍ: OCULTAR SI ES CERO O NO EXISTE */}
          {ou.userCount > 0 && (
            <span className={styles.ouPath}>({ou.userCount})</span>
          )}
          {/* FIN DEL CAMBIO */}

        </div>
        
        {expandedOUs.has(ou.orgUnitPath) && ou.children.length > 0 && (
          <div className={styles.ouChildren}>
            {renderOUTree(ou.children, level + 1)}
          </div>
        )}
      </div>
    ));
  };

  return (
    <div 
      className={`${styles.ouTreePanel} ${isDragging ? styles.dragging : ''}`}
      style={{ 
        width: isMobile ? '100%' : `${panelWidth}px`,
        minWidth: isMobile ? 'auto' : '250px',
        maxWidth: isMobile ? 'none' : '500px'
      }}
    >
      {/* Resize handle para desktop */}
      {!isMobile && (
        <div 
          className={styles.resizeHandle}
          onMouseDown={handleMouseDown}
        />
      )}

      <div className={styles.ouTreeHeader}>
        <div className={styles.headerContent}>
          <FaSitemap className={styles.headerIcon} />
          <span className={styles.headerTitle}>Unidades Organizativas</span>
        </div>
        
        <div className={styles.statusIndicator}>
          <span className={styles.statusText}>
            {organizationalUnits.length} unidades
            {selectedOU && ` • ${selectedOU.split('/').pop()} seleccionada`}
          </span>
        </div>
      </div>
      
      <div className={styles.ouTree}>
        {organizationalUnits.length > 0 ? (
          renderOUTree(organizationalUnits)
        ) : (
          <div className={styles.emptyState}>
            <FaSitemap className={styles.emptyIcon} />
            <p>No hay unidades organizativas</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrganizationalUnits;